import { getAccessToken } from './auth-fn'
import { appConfig } from './config-api'

export {
    getRooms,
    updateRoom,
    removeRoom
}

function getRooms () {
    return fetch(`${appConfig.backendUrl}/rest/room/getall`)
      .then(response => {
          return response.json()
      })
}

function updateRoom (data) {
    return fetch(`${appConfig.backendUrl}/worker/room/type/save`, {
        method: 'POST',
        headers: {
            'authorization': `Bearer ${getAccessToken()}`,
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: data,
    })
      .then(response => {
          return response.json()
      })
}

function removeRoom (data) {
    return fetch(`${appConfig.backendUrl}/worker/room/type/delete`, {
        method: 'POST',
        headers: {
            'authorization': `Bearer ${getAccessToken()}`,
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: data
    })
      .then(response => {
          return response.status === 200
      })
}
